import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';
import '@/lib/recoveryRedirect';

const SUPABASE_URL = "https://bkkxfrbbvchrxcdylyut.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJra3hmcmJidmNocnhjZHlseXV0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYyMzk3NzcsImV4cCI6MjA3MTgxNTc3N30.cp1DbRK044mdCij2aMDFy9jbGJXbQIxTpHKBQ5_Mogs";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
    // Recovery credentials are exchanged explicitly by ResetPassword, avoiding double consumption.
    detectSessionInUrl: typeof window === 'undefined' || window.location.pathname !== '/reset-password',
    // Implicit flow so password-reset links work when opened in a different
    // browser or an email app's in-app browser (PKCE needs the original
    // browser's stored code verifier, which those cases do not have).
    flowType: 'implicit',
  }
});